<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--页头-->
							<div class="page_header">My Tasks</div>
							<!--页头-->
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">
										In the <strong>Unclaimed Tasks</strong> list, click the <strong>"Claim"</strong> button to claim a task related to you, or assign it to another user.
									</div>

									<div class="tips">
										In the <strong>My Tasks</strong> list, locate the change request task you submitted. Click the <strong>"Execute"</strong> button, complete the required information, and submit it. The task will then be moved to the <strong>Unclaimed Tasks</strong> pool.
									</div>

									<div class="tips">
										In the <strong>My Tasks</strong> list, click the <strong>"Execute"</strong> button to review the tasks you have claimed.
									</div>

									<div class="tips">
										To search for a task, enter any related keyword in the search box for quick retrieval.
									</div>

									<div class="tips">
										Click the <strong>"Details"</strong> button to view task information, associated files, and review history.
									</div>
								</div>
								<!-- 未认领 -->
								<unclaimedTask></unclaimedTask>
								<!-- 未认领 -->
								<!-- 提交的任务 -->
								<myTask></myTask>
								<!-- 提交的任务 -->
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import myTask from "./my-task.vue";
	import unclaimedTask from "./unclaimed-task.vue";
	export default {
		components: {
			headers,
			slider,
			myTask,
			unclaimedTask,
		},
		data() {
			return {
				isLoading: true,
			};
		},
		created() {
			let that = this;
			sessionStorage.removeItem("nowIndex");
		},
		mounted() {
			let that = this;
			that.isLoading = false;
		},
		watch: {
			//
		},
		methods: {
			//
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}
</style>